module.exports = __webpack_public_path__ + "img/qrcode_2.509c236.webp";